import { FeatureApi } from '@api/generated/storefront';

const featureApi = new FeatureApi(undefined, '');

export const getFeatureToggles = () => featureApi.featuresUsingGET();
